import "./index.scss";

import {
  CssBaseline,
  Fab,
  Grid,
  Paper,
  Typography
} from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  resetBranch,
  setBranch
} from "../../../../../actions/organisation/actions";
import { IBranch } from "../../../../../reducers/organisation/types";
import { NuvvenTable } from "../../../../common/NuvvenTable/NuvvenTable";

const useStyles = makeStyles(() =>
  createStyles({
    verified: {
      fill: "green"
    }
  })
);
interface BranchListProps {
  branches: IBranch[];
  isUpdateSuccessful: boolean;
  setIsUpdateSuccessful: (isUpdateSuccessful: boolean) => void;
}

export const columns = [
  {
    label: "Name",
    name: "name"
  },
  {
    label: "Address",
    name: "address",
    options: {
      customBodyRender: (value: any) => value.fullAddress || value.street
    }
  },
  {
    label: "Phone",
    name: "phoneNumber.phone"
  },
  {
    label: "Email",
    name: "emailId"
  },
  {
    label: "Manager",
    name: "owner.email"
  },
  {
    label: "Time Zone",
    name: "timeZone"
  }
];

export const VerifiedFormatter = (value: any) => {
  const classes = useStyles();
  return value.value && <CheckCircleOutlineIcon className={classes.verified} />;
};

const BranchList: React.FC<BranchListProps> = (props) => {
  const dispatch = useDispatch();
  const [selection, setSelection] = useState<any[]>([]);
  const [rows, setRows] = useState<any[]>([]);
  const [rowSelected, setRowSelected] = useState<any[]>([]);
  const [updateButtonVisible, setUpdateButtonVisible] = useState<boolean>(
    false
  );

  useEffect(() => {
    if (props.branches) {
      setRows(props.branches);
    }
  }, [props.branches]);

  useEffect(() => {
    if (props.isUpdateSuccessful) {
      setUpdateButtonVisible(false);
      setRowSelected([]);
      props.setIsUpdateSuccessful(false);
    }
  }, [props.isUpdateSuccessful]);

  return (
    <Grid container>
      <CssBaseline />
      <Grid container item xs={6}>
        <Typography variant="h2">Branch List</Typography>
      </Grid>
      <Grid container item xs={6} justifyContent="flex-end">
        <Fab
          variant="extended"
          size="medium"
          aria-label="Update"
          disabled={!updateButtonVisible}
          className={
            updateButtonVisible ? "deleteButton" : "deleteButtonDisable"
          }
          onClick={() => {
            dispatch(
              setBranch({
                ...props.branches.filter(
                  (element: IBranch) => element.id === selection[0].id
                )[0]
              })
            );
          }}
        >
          Update
        </Fab>
      </Grid>
      <Grid container item xs={12} style={{ marginTop: "20px" }}>
        <NuvvenTable
          title={""}
          rows={rows}
          columns={columns}
          setSelection={setSelection}
          options={{
            elevation: 2,
            rowsSelected: rowSelected,
            onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
              if (currentRowsSelected && !rowsSelected?.length) {
                dispatch(resetBranch());
                setRowSelected([]);
                setUpdateButtonVisible(false);
              } else {
                if (currentRowsSelected?.length) {
                  const selectedRow = rows[currentRowsSelected[0].dataIndex];
                  setSelection([selectedRow]);
                  setRowSelected([currentRowsSelected[0].dataIndex]);
                  setUpdateButtonVisible(true);
                }
              }
            }
          }}
        />
      </Grid>
    </Grid>
  );
};

export default BranchList;
